var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgTvBroadcast = function SvgTvBroadcast(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.98 12.708 5.562-3.541-5.563-3.542zM6.874 17.5v-1.667H2.917a1.2 1.2 0 0 1-.875-.375 1.2 1.2 0 0 1-.375-.875V3.75a1.2 1.2 0 0 1 .375-.875 1.2 1.2 0 0 1 .875-.375h14.166a1.2 1.2 0 0 1 .875.375q.375.375.375.875v10.833a1.2 1.2 0 0 1-.375.875 1.2 1.2 0 0 1-.875.375h-3.958V17.5zm-3.958-2.917h14.166V3.75H2.917zm0 0V3.75z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTvBroadcast);
export { ForwardRef as ReactComponent };